import React, { useEffect, useState } from 'react'
import Header from '../Components/Header';
import Auth from '../Function/Auth';
import { toast, ToastContainer } from "react-toastify";
import axios from 'axios';
import Footer from '../Components/Footer';

function Notification() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;

  // Pop Up Setting states
  const [popupImage, setPopupImage] = useState(null)
  const [popupImagePreview, setPopupImagePreview] = useState(null)
  const [popupStatus, setPopupStatus] = useState("disable")

  // Ticker Setting states
  const [tickerDescription, setTickerDescription] = useState("")
  const [tickerStatus, setTickerStatus] = useState("disable")

  const handleProfileDataFetched = (data) => {
    console.log('Admin data', data);
  };

  // Cleanup preview URL when component unmounts
  useEffect(() => {
    return () => {
      if (popupImagePreview) {
        URL.revokeObjectURL(popupImagePreview);
      }
    };
  }, [popupImagePreview]);

// Handle image upload for popup
const handleImageUpload = (e) => {
  const file = e.target.files[0];
  if (file) {
    // Validate file type
    if (!file.type.startsWith('image/')) {
      toast.error('Please select a valid image file');
      return;
    }
    
    // Validate file size (5MB limit)
    if (file.size > 5 * 1024 * 1024) {
      toast.error('Image size should be less than 5MB');
      return;
    }
    
    // Clean up previous preview URL
    if (popupImagePreview) {
      URL.revokeObjectURL(popupImagePreview);
    }
    
    setPopupImage(file);
    // Create preview URL
    const previewUrl = URL.createObjectURL(file);
    setPopupImagePreview(previewUrl);
  }
};

// Clear image preview
const clearImagePreview = () => {
  if (popupImagePreview) {
    URL.revokeObjectURL(popupImagePreview);
  }
  setPopupImage(null);
  setPopupImagePreview(null);
  // Clear the file input
  const fileInput = document.querySelector('input[type="file"]');
  if (fileInput) {
    fileInput.value = '';
  }
};

// Update Popup Setting
const updatePopupSetting = async () => {
  try {
    const formData = new FormData();
    if (popupImage) {
      formData.append('asset_image', popupImage);
    }
    formData.append('status', popupStatus);

    const response = await axios.post(
      `${baseurl}/update-popup-image`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if(response.data.status){
      toast.success(response.data.message);
      // Clear the image preview after successful update
      clearImagePreview();
    }else{
      toast.error(response.data.message);
    }

    console.log('Popup setting updated:', response.data);
  } catch (error) {
    console.error('Update failed:', error.response?.data || error.message);
    toast.error('Failed to update popup setting');
  }
};

// Update Ticker Setting
const updateTickerSetting = async () => {
  try {
    const payload = {
      ticker: tickerDescription,
      status: tickerStatus,
    };

    const response = await axios.post(
      `${baseurl}/update-ticker`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          Accept: 'application/json',
        },
      }
    );

    if(response.data.status){
      toast.success(response.data.message);
    }else{
      toast.error(response.data.message);
    }

    console.log('Ticker setting updated:', response.data);
  } catch (error) {
    console.error('Update failed:', error.response?.data || error.message);
    toast.error('Failed to update ticker setting');
  }
};

  return (
    <>
      <Header>
        {!authToken && <Auth onProfileDataFetched={handleProfileDataFetched} />}
        <ToastContainer />
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">

            </div>
            {/* End Page Header */}

            <div className="row">
              <div className="card">
                <div className="card-body">
                  <div className="tabs-menu ">
                    {/* Tabs */}
                    <ul className="nav nav-tabs profile navtab-custom panel-tabs">
                      <li className="">
                        <a
                          href="#home"
                          data-bs-toggle="tab"
                          className="active"
                          aria-expanded="true"
                        >
                          {" "}
                          <span className="visible-xs">
                            <i className="las la-user-circle fs-16 me-1" />
                          </span>{" "}
                          <span className="hidden-xs">Pop Up Setting</span>{" "}
                        </a>
                      </li>
                      <li className="">
                        <a href="#gallery" data-bs-toggle="tab" aria-expanded="false">
                          {" "}
                          <span className="visible-xs">
                            <i className="las la-images fs-15 me-1" />
                          </span>
                          <span className="hidden-xs">Ticker Setting</span>{" "}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content border border-top-0 p-4 br-dark">
                    <div className="tab-pane border-0 p-0 active" id="home">
                      <h4 className="fs-15 text-uppercase mb-3">Pop Up Setting</h4>
                      <div>
                        <div className="mt-5">
                          <div className="row">
                            <div className="col-6">Pop Up Image</div>
                            <div className="col-6">
                              <input 
                                type="file" 
                                accept="image/*"
                                onChange={handleImageUpload}
                                className="form-control" 
                              />
                              {popupImage && (
                                <small className="text-muted mt-2 d-block">
                                  Selected: {popupImage.name}
                                </small>
                              )}
                              {popupImagePreview && (
                                <div className="mt-3">
                                  <img 
                                    src={popupImagePreview} 
                                    alt="Preview" 
                                    style={{
                                      maxWidth: '200px',
                                      maxHeight: '200px',
                                      objectFit: 'contain',
                                      border: '1px solid #ddd',
                                      borderRadius: '4px',
                                      padding: '5px'
                                    }}
                                  />
                                  <div className="mt-2">
                                    <button 
                                      type="button"
                                      className="btn btn-danger btn-sm"
                                      onClick={clearImagePreview}
                                    >
                                      Clear Image
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="col-6 mt-3">Pop Up Status</div>
                            <div className="col-6 mt-3">
                              <select 
                                className="form-control" 
                                value={popupStatus}
                                onChange={(e) => setPopupStatus(e.target.value)}
                              >
                                <option value="disable">Disable</option>
                                <option value="enable">Enable</option>
                              </select>
                            </div>

                            <div className="col-12 mt-5 text-end">
                              <button 
                                className="btn btn-success btn-sm" 
                                onClick={updatePopupSetting}
                              >
                                Update Pop Up Setting
                              </button>
                            </div>

                          </div>
                        </div>
                        
                      </div>
                    </div>
                    <div className="tab-pane border-0 p-0" id="gallery">
                       <h4 className="fs-15 text-uppercase mb-3">Ticker Setting</h4>
                       <hr/>
                      <div>
                        <div className="mt-5">
                          <div className="row">
                            <div className="col-6">Ticker Description</div>
                            <div className="col-6">
                              <textarea 
                                className="form-control" 
                                rows="4"
                                value={tickerDescription}
                                onChange={(e) => setTickerDescription(e.target.value)}
                                placeholder="Enter ticker description..."
                              />
                            </div>

                            <div className="col-6 mt-3">Ticker Status</div>
                            <div className="col-6 mt-3">
                              <select 
                                className="form-control" 
                                value={tickerStatus}
                                onChange={(e) => setTickerStatus(e.target.value)}
                              >
                                <option value="disable">Disable</option>
                                <option value="enable">Enable</option>
                              </select>
                            </div>

                            <div className="col-12 mt-5 text-end">
                              <button 
                                className="btn btn-success btn-sm" 
                                onClick={updateTickerSetting}
                              >
                                Update Ticker Setting
                              </button>
                            </div>

                          </div>
                        </div>
                        
                      </div>
                    </div>
                   
                  </div>
                </div>
              </div>

            </div>


          </div>
        </div>
      </Header>

      <Footer />

    </>
  )
}

export default Notification